import React, { Component } from "react";
import { render } from 'react-dom';
import { Steps } from 'primereact/steps';
import { Growl } from "primereact/growl";
import { SelectButton } from 'primereact/selectbutton';
import { Button } from 'primereact/button';
import { Messages } from 'primereact/messages';

import FullCalendar from '@fullcalendar/react' // must go before plugins


import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';

import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';

import allLocales from '@fullcalendar/core/locales-all';


import { Formik, Form, Field, FieldArray } from 'formik';
import { FormElements } from "./FormElements";
import { Dropdown } from 'primereact/dropdown';

import Recaptcha from "react-recaptcha";


import { EventService } from '../service/EventService';
import { CalendarService } from "../service/CalendarService";
import { QuestionService } from "../service/QuestionService";
import { NotificationService } from "../service/NotificationService";

import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';

import moment from "moment";
import "moment/locale/sr";

import * as Yup from "yup";
import { populateEvents } from "../helpers/populateEvents";
import { Card } from 'primereact/card';

const tenantName = process.env.REACT_APP_TENANT;


export class CalendarPage extends Component {

    constructor() {
        super();
        let today = new Date();
        let month = today.getMonth();
        let year = today.getFullYear();
        let prevMonth = month === 0 ? 11 : month - 1;
        let prevYear = prevMonth === 11 ? year - 1 : year;


        this.state = {
            // magacini su lokacije
            loading: false,
            warehousesList: [],
            activeIndex: 0,
            selectedCarsType: null,
            selectedCity: null,
            selectedLocation: null,
            selectedLocationID: null,
            selectedCalendar: null,
            selectedCalendarID: null,
            selectedTerm: null,
            selectedTermID: null,
            carsType: [
                { value: 'Putničko', label: 'Putničko' },
                { value: 'SUV', label: 'SUV' },
                { value: 'Kombi', label: 'Kombi' },
            ],
            items: [
                { label: 'Tip vozila' },
                { label: 'Grad/Lokacija' },
                { label: 'Termin' },
                { label: 'Upitnik' }
            ],
            lastLoadedRangeKey: null,

        };

        // magacini


        this.eventService = new EventService();
        this.calendarService = new CalendarService();
        this.questionService = new QuestionService();
        this.notificationService = new NotificationService();


        this.locationTemplate = this.locationTemplate.bind(this);
        this.cityTemplate = this.cityTemplate.bind(this);
        this.onLocationSelect = this.onLocationSelect.bind(this);
        this.onCitySelect = this.onCitySelect.bind(this);
        this.onTermSelect = this.onTermSelect.bind(this);
        this.loadCalendarEvents = this.loadCalendarEvents.bind(this);
        this.onCalendarDatesRender = this.onCalendarDatesRender.bind(this);


        this.eventService = new EventService();
        this.getQuestionFootnote = this.getQuestionFootnote.bind(this);
        this.getQuestionName = this.getQuestionName.bind(this);
        this.allRequired = this.allRequired.bind(this);

        this.onSave = this.onSave.bind(this);
    }

    componentDidMount() {

        const script = document.createElement("script");
        script.src =
            "https://www.google.com/recaptcha/api.js";
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);


        this.questionService.getQuestions().then(data => this.setState({ questions: data }));


        this.calendarService.getCalendars().then(data => {

            // API vraća paginirani odgovor: {count, next, previous, results}
            const calendars = data.results || data;
            
            this.setState({ calendars: calendars });

            // Provera da li postoje aktivni kalendari
            if (!calendars || calendars.length === 0) {
                this.messages.show({
                    severity: 'warn',
                    summary: 'Nema dostupnih kalendara',
                    detail: 'Trenutno nema aktivnih kalendara za zakazivanje termina. Molimo pokušajte kasnije.',
                    sticky: true
                });
                this.setState({ warehousesList: [], citys: [] });
                return;
            }

            const _warehousesList = calendars.map((a) => {

                const container = {};
                container.label = a.warehouse.wh_name;
                container.adress = a.warehouse.wh_adress;
                container.city = a.warehouse.wh_city;
                container.phone = a.warehouse.wh_phone;
                container.value = a.warehouse_id;
                container.key = a.warehouse_id;
                container.warehouse = a.warehouse;
                return container;

            });

            this.setState({ warehousesList: _warehousesList });

            const key = 'city';
            const _city = _warehousesList.map(function (d) { return d[key]; }).filter((v, i, a) => a.indexOf(v) === i);
            const unique = _city.map(function (d) { return { label: d, key: d }; }).filter((v, i, a) => a.indexOf(v) === i);
            this.setState({ citys: unique });

        });


    }

    // proverava da li su svi uneti
    allRequired(valuses) {


        const validateRequire = valuses.ceventanswers_set.filter((a) => {

            if (a.required_field) {
                if (a.answer) { return false } else { return true }
            }
            else return false;

        })
        if (validateRequire.length) {
            console.log('fali', validateRequire.length);
            return false;
        } else {
            return true;
        }
    }



    onCarsTypeSelect(e) {

        const _carsType = e.value;
        if (_carsType) {
            this.setState({ selectedCarsType: _carsType })
            //console.log('cartipe',_carsType);
            //  filtrira  warehousesList i izvlači gradove sa tim tipom vozila
            const key = 'city';
            //console.log('pre',this.state.warehousesList);
            const _warehousesList = this.state.warehousesList.filter((v, i, a) => {
                // proverava da li je cartipe u podesavanjima
                if (v.warehouse.settings) {
                   // console.log('settingscartipe',v.warehouse.settings);
                   
                   // Parsiranje settings ako je JSON string
                   let settingsValue = v.warehouse.settings;
                   try {
                       if (typeof settingsValue === 'string') {
                           settingsValue = JSON.parse(settingsValue);
                       }
                   } catch (e) {
                       // Ako parsing fails, koristi original vrednost
                   }
                   
                   // Ako je settings prazan objekat ili prazan string, prikaži sve kalendare
                   if (!settingsValue || settingsValue === '{}' || 
                       (typeof settingsValue === 'object' && Object.keys(settingsValue).length === 0)) {
                       return true;
                   }
                   
                   // Provera da li settings sadrži carsType
                   if (typeof settingsValue === 'string' && settingsValue.includes(_carsType)) {
                       return true;
                   } else if (typeof settingsValue === 'object' && settingsValue.carsType && 
                              settingsValue.carsType.includes(_carsType)) {
                       return true;
                   } else {
                       return false;
                   }
                } else {
                    // Ako nema settings, prikaži kalendar
                    return true;
                }

            });
            //console.log('poslew',_warehousesList);

            const _city = _warehousesList.map(function (d) { return d[key]; }).filter((v, i, a) => a.indexOf(v) === i);
            const unique = _city.map(function (d) { return { label: d, key: d }; }).filter((v, i, a) => a.indexOf(v) === i);
            this.setState({ citys: unique });

            // Provera da li ima gradova/lokacija pre prelaska na sledeći korak
            if (unique.length === 0) {
                this.growl.show({
                    severity: 'warn',
                    summary: 'Nema dostupnih lokacija',
                    detail: 'Za odabrani tip vozila trenutno nema dostupnih lokacija',
                    life: 5000
                });
                return;
            }

            this.setState({ activeIndex: 1 });
            // this.setState({ selectedLocation: _locations, selectedLocationID: _locations.value })
        }
    }

    onCitySelect(e) {

       

        const _city = e.value;
        if (_city) {
            this.setState({ selectedCity: _city })
            // kreira listu lokacija 
            const _locations = this.state.warehousesList.filter((a) => a.city === _city);
            // u zavisnosti od tipa vozila
            const _locationsForCarType = _locations.filter((v, i, a) => {
                // proverava da li je cartipe u podesavanjima

                if (v.warehouse.settings) { //.carsType
                    // Parsiranje settings ako je JSON string
                    let settingsValue = v.warehouse.settings;
                    try {
                        if (typeof settingsValue === 'string') {
                            settingsValue = JSON.parse(settingsValue);
                        }
                    } catch (e) {
                        // Ako parsing fails, koristi original vrednost
                    }
                    
                    // Ako je settings prazan objekat ili prazan string, prikaži sve kalendare
                    if (!settingsValue || settingsValue === '{}' || 
                        (typeof settingsValue === 'object' && Object.keys(settingsValue).length === 0)) {
                        return true;
                    }
                    
                    // Provera da li settings sadrži carsType
                    if (typeof settingsValue === 'string' && settingsValue.includes(this.state.selectedCarsType)) {
                        return true;
                    } else if (typeof settingsValue === 'object' && settingsValue.carsType && 
                               settingsValue.carsType.includes(this.state.selectedCarsType)) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    // Ako nema settings, prikaži kalendar
                    return true;
                }

            });
           // console.log('CITY', _locationsForCarType);
            this.setState({ locationInCity: _locationsForCarType })
            this.setState({ activeIndex: 1 });
            // this.setState({ selectedLocation: _locations, selectedLocationID: _locations.value })
        }
    }

    onLocationSelect(e) {

        const _location = e;
        // set loading
        this.setState({ loading: true });
      
        if (_location) {


            this.setState({ selectedLocationID: _location.value })

            // this.state.selectedCalendar && this.state.activeIndex == 2 
            const _selectedLocation = this.state.warehousesList.filter((a) => a.value === _location.value)
            console.log('selectedLocation', _selectedLocation[0]);
            this.setState({ selectedLocation: _selectedLocation[0] })

            // zatim ucitava kalendar
            // i termine za taj kalendar
            // uzima kalendar na osnovu ID magacina

            this.calendarService.getCalendarsByWh(_location.value).then((data) => {
                const calendars = data.map((cal) => {


                    const _calendar = {};

                    _calendar.name = cal.calendar_name;
                    _calendar.code = cal.id;
                    _calendar.start_days = cal.start_days;
                    _calendar.end_days = cal.end_days;

                    _calendar.label = cal.calendar_name;
                    _calendar.max_event_number = cal.max_event_number;
                    _calendar.event_duration_calendar = cal.event_duration_calendar;
                    _calendar.starttime = cal.cbusinesshours_set[0].starttime;
                    const _businessHours = cal.cbusinesshours_set.map((bh) => {
                        const _bh = {};
                        // prepravka malih slova u camelcase
                        _bh.daysOfWeek = bh.daysofweek;
                        _bh.startTime = bh.starttime;
                        _bh.endTime = bh.endtime;
                        _bh.break_start_time = bh.break_start_time;
                        _bh.break_end_time = bh.break_end_time;

                        return _bh;
                    });

                    _calendar.businessHours = _businessHours

                    return _calendar;

                });
                this.setState({ selectedCalendar: calendars[0] })

                if (calendars[0]) {
                    const rangeStart = moment().startOf('day').add(calendars[0].start_days || 0, 'days').toDate();
                    const rangeEnd = moment(rangeStart).add(7, 'days').toDate();

                    this.loadCalendarEvents(calendars[0], rangeStart, rangeEnd, true);
                } else {
                    this.setState({ loading: false });
                    this.growl.show({ severity: 'warn', summary: 'Ova lokacija nema dostupan kalendar', detail: 'Prepraviti api' });
                }
            }).catch((e) => {
                this.setState({ loading: false });
                if (e.response) {
                    // console.log('GRESKA', e.response);
                }
            });

        }

    }

    loadCalendarEvents(calendar, rangeStart, rangeEnd, activateTermStep = false) {
        if (!calendar || !rangeStart || !rangeEnd) {
            return;
        }

        const startDate = moment(rangeStart).format('YYYY-MM-DD');
        const endDate = moment(rangeEnd).format('YYYY-MM-DD');
        const rangeKey = `${calendar.code}_${startDate}_${endDate}`;

        if (this.state.lastLoadedRangeKey === rangeKey && !activateTermStep) {
            return;
        }

        this.setState({ loading: true, lastLoadedRangeKey: rangeKey });

        this.eventService.getEventsByCalendar(calendar.code, startDate, endDate).then(data => {
            const _events = populateEvents(data, calendar, rangeStart, rangeEnd);
            const nextState = { events: _events, loading: false };

            if (activateTermStep) {
                nextState.activeIndex = 2;
            }

            this.setState(nextState);
        }).catch(() => {
            this.setState({ loading: false });
            this.growl.show({
                severity: 'error',
                summary: 'Greška pri učitavanju termina',
                detail: 'Termin nije učitan. Pokušajte ponovo ili izaberite drugu lokaciju.',
                life: 5000,
            });
        });
    }

    onCalendarDatesRender(arg) {
        if (!this.state.selectedCalendar || !arg || !arg.view) {
            return;
        }

        this.loadCalendarEvents(
            this.state.selectedCalendar,
            arg.view.activeStart,
            arg.view.activeEnd
        );
    }

    onTermSelect(e, c) {

        const _start = e.event.start;

        if (e.event.extendedProps.disabled) {
            const durationMinutes = parseInt(c.event_duration_calendar, 10) || 30;

            const ceventanswersSet = this.state.questions.map((q) => {
                const _answer = {};
                _answer.question = q.id;
                _answer.order_number = q.question_order;
                _answer.answer = q.dafault_answer;
                _answer.active = true;
                _answer.required_field = q.required_field;
                _answer.user_created_id = 1;
                _answer.created_dt = moment().format();
                _answer.user_last_modf_id = 1;
                _answer.last_modif_dt = moment().format();
                _answer.tenant_id = 1;

                return _answer;
            })

            const newEvent = {
                "ceventanswers_set": [],
                "calendar": c.code, // defaultni kalendar
                "term": 1,
                "date": 20210107, // zakucano treba skloniti
                "title": "Zahtev sa sajta",
                "event_start": e.start,
                "event_end": moment(e.start).add(durationMinutes, 'minutes'),
                "status": 2,
                "accepted": moment(),
                "user_accepted_id": 1,
                "user_created_id": 1,
                "created_dt": moment(),
                "user_last_modf_id": 1,
                "last_modif_dt": moment(),
                "tenant_id": 1,
                "business_partner_id": null
            };

            // console.log("CES", ceventanswersSet);

            newEvent.ceventanswers_set = ceventanswersSet;
            newEvent.event_start = _start;
            newEvent.event_end = moment(_start).add(durationMinutes, 'minutes');
            this.setState({ selectedTerm: newEvent })
            this.setState({ activeIndex: 3 });
        } else {
            this.growl.show({ severity: 'warn', summary: 'Ovaj termin je zauzet', detail: 'Odaberite drugi termin' });
        }
    }

    cityTemplate(option) {
        const logoPath = 'assets/layout/images/v-city.png';

        return (
            <div style={{ textAlign: 'center', padding: '1em', width: '125px' }}>
                <img alt={option.label} src={logoPath} style={{ height: '48px' }} />
                <div style={{ marginTop: '1em' }}>{option.label}</div>
            </div>
        )
    }

    locationTemplate(option) {
        const logoPath = 'assets/layout/images/v-location.png';

        return (
            <div style={{ textAlign: 'center', padding: '1em', width: '125px' }}>
                <img alt={option.label} src={logoPath} style={{ height: '48px' }} />
                <div style={{ marginTop: '1em' }}>{option.label}</div>
            </div>
        )
    }

    carTemplate(option) {
        const logoPath = 'showcase/demo/images/car/' + option.brand + '.png';

        return (
            <div style={{ textAlign: 'center', padding: '1em', width: '125px' }}>
                <img alt={option.brand} src={logoPath} srcSet="https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png" style={{ width: '48px' }} />
                <div style={{ marginTop: '1em' }}>{option.brand}</div>
            </div>
        )
    }



    // pamcenje
    onSave(data) {

        // izvlazi podatke iz objekta

        let _sendEmailToLocationVal = 1;
        let _plateVal = '';

        if (data) {
            // zakucano na odgovore prama id pitanja
            let _plate = data.ceventanswers_set.filter((x) => x.question === 2);
            let _sendEmailToLocation = data.ceventanswers_set.filter((x) => x.question === 8);

            if (_plate[0]) {
                _plateVal = _plate[0].answer;
            }
            if (_sendEmailToLocation[0]) {
                _sendEmailToLocationVal = _sendEmailToLocation[0].answer;
            }

        }



        // malo prepakujemo podatke 

        let _data = {
            ...data,
            "client": "online",
            "send_email_to_location": _sendEmailToLocationVal ? 1 : 0,
            "plate": _plateVal,
            "title": _plateVal
        };

        this.eventService.createEvent(_data)
            .then((res) => {
                this.growl.show({ severity: 'success', summary: 'Uspešno', detail: 'Uspešno ste zakazali termin!' });

                // treba da izvuce mail iz liste odgovora
                //const clientText = "Poštovani, Uspešno ste pzakazali termin. Hvala na poverenju!";
                //const adminText = "Pristigao je novi zahtev";
                // treba da pošalje obavestenje klijentu
                //this.notificationService.sendNotification('Potvrda slanja zahteva', clientText, 'nikola.tomic@diginout.com');
                // treba da pošalje obavestenje nekom iz pneumastera
                //this.notificationService.sendNotification('Novi zahtev', adminText, 'nikola.tomic@diginout.com');
                this.setState({ activeIndex: 4 });

            })
            .catch(e => {
                const { detail } = e.response.data;
                if (e.response) {
                  this.growl.show({ severity: 'error', summary: 'Greška', detail: detail, life: 10000 });
        
                 
                }
              });
    }


    getQuestionName = (id) => {

        let filtered = this.state.questions.filter(a => a.id === id);
        if (filtered[0]) {
            return filtered[0].question_name;
        } else {
            return ''
        }
    }

    getQuestionFootnote = (id) => {
        let filtered = this.state.questions.filter(a => a.id === id);
        if (filtered[0]) {
            return filtered[0].footnote;
        } else {
            return ''
        }
    }

    render() {

      

        // logo setings

        const logo = 'assets/layout/images/pneumaster-logo.png';

        const interactiveItems = [{
            label: this.state.items[0].label,
            command: (event) => {
                // console.log(event);
                // this.growl.show({ severity: 'warn', summary: this.state.items[0].label, detail: event.item.label });
            }
        },
        {
            label: this.state.items[1].label,
            command: (event) => {
                // this.growl.show({ severity: 'warn', summary: this.state.items[1].label, detail: event.item.label });
            }
        },
        {
            label: this.state.items[2].label,
            command: (event) => {
                // this.growl.show({ severity: 'warn', summary: this.state.items[2].label, detail: event.item.label });
            }
        },
        {
            label: this.state.items[3].label,
            command: (event) => {
                //this.growl.show({ severity: 'warn', summary: this.state.items[3].label, detail: event.item.label });
            }
        }
        ];

        return (
            <div className="p-grid ">
                <Growl ref={(el) => (this.growl = el)} />
               

                <div className="p-xl-2 p-lg-2 p-md-2 p-sm-12"></div>
                

                <div className="p-xs-12 p-xl-8 p-lg-8 p-md-8 p-sm-12">
                    <div className="p-grid">                       
                        <div className=" p-md-12 p-sm-12">
                            <Card title="Informacije o terminu" >
                                <p>Tip vozila: <b style={{ fontWeight: 'bold' }}>{this.state.selectedCarsType}</b></p>
                                <p>Selektovani grad: <b style={{ fontWeight: 'bold' }}>{this.state.selectedCity}</b></p>
                                <p>Selektovana lokacija: <b style={{ fontWeight: 'bold' }}>
                                    {this.state.selectedLocation ? this.state.selectedLocation.label + ', ' + this.state.selectedLocation.adress : ''}
                                </b></p>
                                <p>Selektovani termin: <b style={{ fontWeight: 'bold' }}>{this.state.selectedTerm ? moment(this.state.selectedTerm.event_start).format('dddd, DD-MM-YYYY u HH:mm') : ''}</b></p>

                            </Card>
                        </div>

                    </div>
                    <div className="card">
                        {this.state.activeIndex < 4 ?
                            <Steps model={interactiveItems} className="custom-step" activeIndex={this.state.activeIndex} onSelect={(e) => this.setState({ activeIndex: e.index })} readOnly={false} />
                            : ""
                        }
                        {this.state.activeIndex == 4 &&
                            <div>
                                <h3>Hvala!</h3>
                                <div>Uspešno ste zakazali termin.</div>
                            </div>
                        }


                        {this.state.activeIndex == 0 &&
                            <div>
                                <h3>Odaberite tip vozila</h3>
                                <SelectButton value={this.state.selectedCarsType} options={this.state.carsType} onChange={(e) => {
                                    this.onCarsTypeSelect(e);
                                }} optionLabel="label" optionValue="label" />
                            </div>
                        }

                        {this.state.selectedCarsType && this.state.activeIndex == 1 &&
                            <div>
                                {/* loading indications */}
                                {this.state.loading && <div className="p-d-flex p-ai-center p-jc-center"><i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>  Učitavanje slobodnih termina</div>}

                                <h3>Odaberite grad</h3>
                                <SelectButton value={this.state.selectedCity} options={this.state.citys} onChange={(e) => {
                                    this.onCitySelect(e);
                                }}
                                    // itemTemplate={this.cityTemplate}
                                    optionLabel="label" optionValue="label" />

                                <h3>Odaberite lokaciju</h3>
                                <SelectButton value={this.state.selectedCalendarID} options={this.state.locationInCity}
                                    onChange={(e) => { this.onLocationSelect(e); }}
                                    // itemTemplate={this.locationTemplate} 
                                    optionLabel="label" optionValue="value" />
                            </div>
                        }
                        {this.state.selectedCalendar && this.state.activeIndex == 2 &&
                            <div>
                                <h3>Odaberite termin</h3>

                                {this.state.loading && <div className="p-d-flex p-ai-center p-jc-center" style={{ marginBottom: '1rem' }}><i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>  Učitavanje slobodnih termina</div>}

                                <FullCalendar
                                    firstDay={1}
                                    events={this.state.events}
                                    plugins={[dayGridPlugin, timeGridPlugin]}
                                    defaultView='timeGridSevenDays'
                                    defaultDate={moment(new Date()).add(this.state.selectedCalendar.start_days, 'd').format()}
                                    locales={allLocales}
                                    locale='sr'

                                    minTime="08:30"
                                    maxTime="20:30"
                                    views={{
                                        timeGridSevenDays: {
                                            type: 'timeGrid',
                                            duration: { days: 7 },
                                            buttonText: 'Narednih 7 dana'
                                        }
                                    }}

                                    header={{
                                        left: 'prev',
                                        center: 'title',
                                        right: 'next'
                                    }}
                                    datesRender={(arg) => this.onCalendarDatesRender(arg)}
                                    // ref={calendarComponentRef}
                                    editable={false}
                                    selectable={true}
                                    businessHours={this.state.businessHours}
                                    eventConstraint={this.state.businessHours}
                                    droppable={false}
                                    allDaySlot={false}
                                    slotDuration="01:00:00"
                                    eventClick={(e) => {

                                        // console.log(e);
                                        this.onTermSelect(e, this.state.selectedCalendar);

                                    }}
                                />

                            </div>
                        }

                        {this.state.selectedTerm && this.state.activeIndex == 3 &&
                            <div>
                                <h3>Upitnik</h3>
                                <Formik

                                    initialValues={this.state.selectedTerm ? this.state.selectedTerm : {}}
                                    enableReinitialize
                                    validationSchema={Yup.object().shape({
                                        recaptcha: Yup.string().required(),
                                    })}
                                    onSubmit={(values, actions, setErrors) => {
                                        switch (values.btnAction) {
                                            case "SAVE":
                                                if (this.allRequired(values)) {
                                                    this.onSave(values);
                                                } else {
                                                    this.growl.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Morate popuniti sva obavezna polja!' });
                                                }
                                                break;
                                            default: return false;
                                        }

                                    }

                                    }
                                >
                                    {this.state.selectedTerm ? ({ values,
                                        setFieldValue,
                                        dirty,
                                        handleSubmit,
                                        errors,
                                        touched,
                                        setErrors,
                                        meta
                                    }) => (
                                        <Form id="formid">

                                            <div className="p-grid">
                                                <div className="p-col">
                                                    <div className="p-fluid">


                                                    </div>
                                                    <br></br>
                                                    <FieldArray
                                                        name="ceventanswers_set"
                                                        render={arrayHelpers => (
                                                            <div className="p-fluid">
                                                                {values.ceventanswers_set && values.ceventanswers_set.length > 0 ? (
                                                                    values.ceventanswers_set.map((ceventanswers_set, index) => (

                                                                        <div key={index} className="p-field p-grid">
                                                                            <label htmlFor={`ceventanswers_set.${index}.answer`} className="p-col-12 p-md-6">
                                                                                {this.getQuestionName(ceventanswers_set.question)}

                                                                                {ceventanswers_set.required_field ? <span style={{ color: "red" }}>*</span> : ''}
                                                                            </label>
                                                                            <div className="p-col-12 p-md-6">
                                                                                <Field
                                                                                    name={`ceventanswers_set.${index}.answer`}
                                                                                    id={`ceventanswers_set.${index}.answer`}
                                                                                    questions={this.state.questions}
                                                                                    question_id={ceventanswers_set.question}
                                                                                    component={FormElements}
                                                                                />
                                                                                <small>{this.getQuestionFootnote(ceventanswers_set.question)}</small>
                                                                            </div>

                                                                        </div>

                                                                    ))
                                                                ) : (
                                                                    ''
                                                                )}
                                                                <div>

                                                                </div>
                                                            </div>
                                                        )}
                                                    />
                                                    {/* 6Lcvna0pAAAAALPNhnzza8_x2BUgG-P0r5tN1Ccf */}
                                                    {/* 6Lcvna0pAAAAAP2MIPEMrRkjVdLtNKDTXLkkpKQm */}
                                                    <Recaptcha
                                                        sitekey="6LdoRAQrAAAAAOkSA6sbiuRy6Tm576PfHomB045N"
                                                        render="explicit"
                                                        verifyCallback={(response) => { setFieldValue("recaptcha", response); }}
                                                        onloadCallback={() => { console.log("done loading!"); }}
                                                    />
                                                    {errors.recaptcha
                                                        && touched.recaptcha && (
                                                            <p>{errors.recaptcha}</p>
                                                        )}
                                                </div>

                                            </div>
                                            <div className="p-grid">
                                                <div className="p-col">

                                                    <Button type="submit" disabled={!dirty} label="Zakaži termin" icon="pi pi-check" className="p-button-text" onClick={(e) => {
                                                        setFieldValue("btnAction", "SAVE");
                                                        handleSubmit(e);
                                                    }} />
                                                </div>
                                            </div>
                                            {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                                        </Form>
                                    ) : ''}
                                </Formik></div>
                        }

                    </div>
                </div>
                <div className=" p-xl-2 p-lg-2 p-md-2 p-sm-12">
              
                        
                      
                </div>

                {/* div with content in center */}
                <div className="p-xl-2 p-lg-2 p-md-2 p-sm-12" style={{width:'100%'}}>
                    <div className="p-xl-2 p-lg-2 p-md-2 p-sm-12" style={{width:'100%', textAlign: 'center'}}>
                        {/* <img src={logo} style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', width: '200px' }} /> */}
                        {/* <p>Powered by <a href="https://tirehotelapp.com" target="_blank">www.tirehotelapp.com</a></p> */}
                    </div>
                    
                </div>
                
                {/* <pre>{JSON.stringify(this.state.questions, null, 2)}</pre>
                <pre>{JSON.stringify(this.state.citys, null, 2)}</pre>
                <pre>{JSON.stringify(this.state.warehousesList, null, 2)}</pre>
                <pre>{JSON.stringify(this.state.locationInCity, null, 2)}</pre> */}
            </div>
        );
    }
}
